import { MethodType, ParamsFetchType, GenerateUrlApiType, ResponseType } from 'src_common/browser/apiUtils';
import { GenerateUrlApiParamsType } from 'src_common/server/webDriver/sdkApiWebUtils';
import { openapi_website_cms_getLiveNotificationsActive, decodeResponse200, Response200Type } from 'src/api_openapi/generated/openapi_website_cms_getLiveNotificationsActive';
import { EventId } from 'src_common/common/websocket2/id/WebsocketId';

export type LiveNotificationsModelApiType = Response200Type extends Array<infer Model> ? Model : never;

export interface LiveNotificationsModelType {
    cta_event?: null | undefined | EventId;
    cta_game?: null | undefined | string;
    cta_html_link?: null | undefined | string;
    cta_text?: null | undefined | string;
    date_from?: null | undefined | string;
    date_to?: null | undefined | string;
    display_order: number;
    id: number;
    img_url?: null | undefined | string;
    is_active: boolean;
    is_show_for_all_users: boolean;
    message_text?: null | undefined | string;
    title: string;
    universe: string;
    users_ids: unknown;
    visibility_option?: null | undefined | string;
};

const decode = (status: number, data: ResponseType): Array<LiveNotificationsModelApiType> => {
    if (status === 200 && data.type === 'json') {
        return decodeResponse200(data.json);
    }
    if (status === 404 || status === 500) {
        return [];
    }

    throw new Error(`unhandled response ${status} - ${data.type}`);
};

export const getLiveNotificationsActive = {
    browser: {
        params: (): ParamsFetchType<void> => {
            return {
                type: MethodType.GET,
                url: '/api-web/get-live-notifications-active',
            };
        },
        decode: decode
    },
    express: {
        method: MethodType.GET,
        urlBrowser: '/api-web/get-live-notifications-active',
    },
    generateUrlApi: async (params: GenerateUrlApiParamsType<void>): Promise<GenerateUrlApiType> => {

        const response = await openapi_website_cms_getLiveNotificationsActive(params.API_URL, params.API_TIMEOUT, params.jwtToken, {
            universe: params.API_UNIVERSE
        });

        return {
            passToBackend: false,
            status: response.status,
            responseBody: response.body
        };
    }
};
